import { useApolloClient } from "@apollo/client";

import { READ_OTA_HMAC_QUERY } from "graphqlQueries/packages";
import { readOtaHmacQueryMapper } from "graphqlQueries/packages.map";

export default function useOtaHmacData() {
  const client = useApolloClient();

  return () =>
    readOtaHmacQueryMapper(client.readQuery({ query: READ_OTA_HMAC_QUERY }));
}
